// Client-safe: the leaderboard prize panel reads these too, so keep imports type-only.
import type { cosmetic_type } from "@db";

export type WeeklyRewardItemType =
	"field" | (typeof cosmetic_type.enumValues)[number];

export type WeeklyPlaceReward = {
	place: number;
	coins: number;
	plusDays?: number;
	items?: WeeklyRewardItemType[];
	// Given on top of `items` when the winner already has Plus.
	itemsInsteadOfPlus?: WeeklyRewardItemType[];
};

export const WEEKLY_TOP_REWARDS: WeeklyPlaceReward[] = [
	{
		place: 1,
		coins: 3000,
		plusDays: 7,
		items: ["field", "dice_design"],
		itemsInsteadOfPlus: ["field", "dice_roll", "card_background"],
	},
	{
		place: 2,
		coins: 1500,
		plusDays: 3,
		items: ["field"],
		itemsInsteadOfPlus: ["field", "card_background", "dice_design"],
	},
	{
		place: 3,
		coins: 1000,
		plusDays: 1,
		items: ["field"],
		itemsInsteadOfPlus: ["field", "dice_design"],
	},
	{ place: 4, coins: 900 },
	{ place: 5, coins: 800 },
	{ place: 6, coins: 700 },
	{ place: 7, coins: 600 },
	{ place: 8, coins: 500 },
	{ place: 9, coins: 400 },
	{ place: 10, coins: 300 },
];

// Weeks before this one ended before payouts existed and are never paid.
export const FIRST_REWARDED_WEEK_START = "2026-10-19";
